import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=28c5a334&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5a334",
  null
  
)

export default component.exports